import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { AuthGuard } from '@/features/auth/components/AuthGuard'
import { ErrorBoundary } from '@/shared/components/ErrorBoundary'
import { LoadingSpinner } from '@/shared/components/LoadingSpinner'
import { AppShell } from './AppShell'
import { ROUTES } from '@/shared/lib/routes'

const LoginPage = lazy(() =>
  import('@/features/auth/components/LoginPage').then((m) => ({
    default: m.LoginPage,
  })),
)
const ExpenseForm = lazy(() =>
  import('@/features/expenses/components/ExpenseForm').then((m) => ({
    default: m.ExpenseForm,
  })),
)
const ExpenseListPage = lazy(() =>
  import('@/features/expenses/components/ExpenseListPage').then((m) => ({
    default: m.ExpenseListPage,
  })),
)
const ExpenseDetailPage = lazy(() =>
  import('@/features/expenses/components/ExpenseDetailPage').then((m) => ({
    default: m.ExpenseDetailPage,
  })),
)
const ExpenseEditPage = lazy(() =>
  import('@/features/expenses/components/ExpenseEditPage').then((m) => ({
    default: m.ExpenseEditPage,
  })),
)

function AuthenticatedLayout() {
  return (
    <AuthGuard>
      <AppShell>
        <ErrorBoundary>
          <Suspense fallback={<LoadingSpinner />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </AppShell>
    </AuthGuard>
  )
}

export function AppRoutes() {
  return (
    <Routes>
      <Route
        path={ROUTES.login}
        element={
          <ErrorBoundary>
            <Suspense fallback={<LoadingSpinner />}>
              <LoginPage />
            </Suspense>
          </ErrorBoundary>
        }
      />
      <Route element={<AuthenticatedLayout />}>
        <Route path={ROUTES.home} element={<ExpenseForm />} />
        <Route path={ROUTES.expenses} element={<ExpenseListPage />} />
        <Route
          path={`${ROUTES.expenses}/:id`}
          element={<ExpenseDetailPage />}
        />
        <Route
          path={`${ROUTES.expenses}/:id/edit`}
          element={<ExpenseEditPage />}
        />
      </Route>
      <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
    </Routes>
  )
}
